export const Header: React.FC = () => {
  return (
    <header className="h-20 flex flex-col justify-center items-center">
      <h1 className="text-[2em]  dark:text-gray-300">GitHub User Search</h1>
    </header>
  );
};
